import { actionTypes } from './constants';

const initialState = {
  // Métier
  selectedActivity: null,
  selectedDate: null,
  selectedDuration: null,
  selectedResource: null,
  selectedPlayers: [],
  // UX
  error: null,
  activeOption: 0,
  showAvailability: false,
  types: [],
  typesFilters: [],
};

const isAnonymous = (player) => player.reference === 'UNKNOWN' && player.type === 'anonymous';

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ACTIVITY:
      return { ...state, selectedActivity: action.payload };
    case actionTypes.SET_DATE:
      return { ...state, selectedDate: action.payload };
    case actionTypes.SET_DURATION:
      return { ...state, selectedDuration: action.payload };
    case actionTypes.SET_RESOURCE:
      return { ...state, selectedResource: action.payload };
    case actionTypes.SET_PLAYERS:
      return { ...state, selectedPlayers: action.payload };
    case actionTypes.ADD_PLAYER:
      return {
        ...state,
        selectedPlayers: [...state.selectedPlayers, action.payload],
      };
    case actionTypes.REMOVE_LAST_PLAYER: {
      const anonymousIndexes = state.selectedPlayers.map((p, i) => (isAnonymous(p) ? i : -1)).filter((i) => i !== -1);

      if (anonymousIndexes.length > 0) {
        const removeIndex = anonymousIndexes[anonymousIndexes.length - 1];
        return {
          ...state,
          selectedPlayers: state.selectedPlayers.filter((_, i) => i !== removeIndex),
        };
      }

      if (state.selectedPlayers.length === 0) return state;

      return {
        ...state,
        selectedPlayers: state.selectedPlayers.slice(0, -1),
      };
    }
    case actionTypes.ASSIGN_PLAYER: {
      const index = state.selectedPlayers.findIndex((p) => isAnonymous(p));
      if (index === -1) return state;

      return {
        ...state,
        selectedPlayers: state.selectedPlayers.map((p, i) => (i === index ? action.payload : p)),
      };
    }
    case actionTypes.REPLACE_PLAYER_AT: {
      const { index, player } = action.payload;
      if (!state.selectedPlayers[index]) return state;

      return {
        ...state,
        selectedPlayers: state.selectedPlayers.map((p, i) => (i === index ? player : p)),
      };
    }
    case actionTypes.INIT_STATE:
      return { ...initialState, ...action.payload };
    case actionTypes.SET_ACTIVE_OPTION:
      return { ...state, activeOption: action.payload };
    case actionTypes.SET_SELECTED_DURATION:
      return { ...state, selectedDuration: action.payload };
    case actionTypes.SET_SHOW_AVAILABILITY:
      return { ...state, showAvailability: action.payload };
    case actionTypes.SET_TYPES:
      return { ...state, types: action.payload };
    case actionTypes.SET_TYPES_FILTERS:
      return { ...state, typesFilters: action.payload };
    case actionTypes.SET_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
